import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7395077a = () => interopDefault(import('..\\pages\\access-your-card.vue' /* webpackChunkName: "pages_access-your-card" */))
const _57c81ab2 = () => interopDefault(import('..\\pages\\card-print.vue' /* webpackChunkName: "pages_card-print" */))
const _39440f29 = () => interopDefault(import('..\\pages\\cookie-policy.vue' /* webpackChunkName: "pages_cookie-policy" */))
const _4ceeb232 = () => interopDefault(import('..\\pages\\program-requirements\\index.vue' /* webpackChunkName: "pages_program-requirements_index" */))
const _404c271c = () => interopDefault(import('..\\pages\\rebate-form.vue' /* webpackChunkName: "pages_rebate-form" */))
const _0ce1c174 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _6a288029 = () => interopDefault(import('..\\pages\\view-your-account.vue' /* webpackChunkName: "pages_view-your-account" */))
const _3346c217 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _3354d998 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _3371089a = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _337f201b = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _682cfd58 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _1ff17830 = () => interopDefault(import('..\\pages\\program-requirements\\icotyde.vue' /* webpackChunkName: "pages_program-requirements_icotyde" */))
const _8ebc5f7c = () => interopDefault(import('..\\pages\\program-requirements\\imaavy.vue' /* webpackChunkName: "pages_program-requirements_imaavy" */))
const _85689838 = () => interopDefault(import('..\\pages\\program-requirements\\inlexzo.vue' /* webpackChunkName: "pages_program-requirements_inlexzo" */))
const _dca5af34 = () => interopDefault(import('..\\pages\\program-requirements\\mm1.vue' /* webpackChunkName: "pages_program-requirements_mm1" */))
const _20d6b1cf = () => interopDefault(import('..\\pages\\program-requirements\\program-requirement.vue' /* webpackChunkName: "pages_program-requirements_program-requirement" */))
const _7ae70ee9 = () => interopDefault(import('..\\pages\\program-requirements\\remicade.vue' /* webpackChunkName: "pages_program-requirements_remicade" */))
const _61fd9398 = () => interopDefault(import('..\\pages\\program-requirements\\rybrevant.vue' /* webpackChunkName: "pages_program-requirements_rybrevant" */))
const _3a53e6b4 = () => interopDefault(import('..\\pages\\program-requirements\\simponi.vue' /* webpackChunkName: "pages_program-requirements_simponi" */))
const _0794de4f = () => interopDefault(import('..\\pages\\program-requirements\\simponiAria.vue' /* webpackChunkName: "pages_program-requirements_simponiAria" */))
const _4221265d = () => interopDefault(import('..\\pages\\program-requirements\\stelara.vue' /* webpackChunkName: "pages_program-requirements_stelara" */))
const _2ce16d46 = () => interopDefault(import('..\\pages\\program-requirements\\stelara-standard.vue' /* webpackChunkName: "pages_program-requirements_stelara-standard" */))
const _635f775d = () => interopDefault(import('..\\pages\\program-requirements\\tremfya-standard.vue' /* webpackChunkName: "pages_program-requirements_tremfya-standard" */))
const _6e26bdc0 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/access-your-card",
    component: _7395077a,
    name: "access-your-card"
  }, {
    path: "/card-print",
    component: _57c81ab2,
    name: "card-print"
  }, {
    path: "/cookie-policy",
    component: _39440f29,
    name: "cookie-policy"
  }, {
    path: "/program-requirements",
    component: _4ceeb232,
    name: "program-requirements"
  }, {
    path: "/rebate-form",
    component: _404c271c,
    name: "rebate-form"
  }, {
    path: "/unlock",
    component: _0ce1c174,
    name: "unlock"
  }, {
    path: "/view-your-account",
    component: _6a288029,
    name: "view-your-account"
  }, {
    path: "/errors/400",
    component: _3346c217,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _3354d998,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _3371089a,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _337f201b,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _682cfd58,
    name: "errors-500"
  }, {
    path: "/program-requirements/icotyde",
    component: _1ff17830,
    name: "program-requirements-icotyde"
  }, {
    path: "/program-requirements/imaavy",
    component: _8ebc5f7c,
    name: "program-requirements-imaavy"
  }, {
    path: "/program-requirements/inlexzo",
    component: _85689838,
    name: "program-requirements-inlexzo"
  }, {
    path: "/program-requirements/mm1",
    component: _dca5af34,
    name: "program-requirements-mm1"
  }, {
    path: "/program-requirements/program-requirement",
    component: _20d6b1cf,
    name: "program-requirements-program-requirement"
  }, {
    path: "/program-requirements/remicade",
    component: _7ae70ee9,
    name: "program-requirements-remicade"
  }, {
    path: "/program-requirements/rybrevant",
    component: _61fd9398,
    name: "program-requirements-rybrevant"
  }, {
    path: "/program-requirements/simponi",
    component: _3a53e6b4,
    name: "program-requirements-simponi"
  }, {
    path: "/program-requirements/simponiAria",
    component: _0794de4f,
    name: "program-requirements-simponiAria"
  }, {
    path: "/program-requirements/stelara",
    component: _4221265d,
    name: "program-requirements-stelara"
  }, {
    path: "/program-requirements/stelara-standard",
    component: _2ce16d46,
    name: "program-requirements-stelara-standard"
  }, {
    path: "/program-requirements/tremfya-standard",
    component: _635f775d,
    name: "program-requirements-tremfya-standard"
  }, {
    path: "/",
    component: _6e26bdc0,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
